export default __webpack_public_path__ + "static/media/2-5-1.9bc51e03.jpg";